import { AvField, AvForm } from "availity-reactstrap-validation"
import UseImageUploader from "components/imageUploader/useImageUploader"
import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { CardTitle, Col, Modal, ModalBody, Row } from "reactstrap"

// import Select from "react-select"
import { createShowroom, updateShowroom } from "store/actions"

const ShowroomModal = ({
  show,
  onCloseClick,
  updateData,
  imagesPreview,
  setImagesPreview,
}) => {
  const dispatch = useDispatch()

  const [imageError, setImageError] = useState("")

  useEffect(() => {
    if (updateData?._id) {
      setImagesPreview(updateData?.images)
    }
  }, [updateData])

  const handleValidSubmit = (e, v) => {
    if (!imagesPreview.length) {
      setImageError("Please upload one image")
      return
    }
    setImageError("") // clear error when valid

    const Update = {
      google_map_url: v?.google_map_url,
      ...(v?.priority !== undefined && v?.priority !== ""
        ? { priority: Number(v.priority) }
        : {}),
      images: imagesPreview,
    }
    if (updateData?._id) {
      dispatch(updateShowroom(Update, updateData?._id, onCloseClick))
      // onCloseClick
    } else {
      const Create = {
        google_map_url: v?.google_map_url,
        ...(v?.priority !== undefined && v?.priority !== ""
          ? { priority: Number(v.priority) }
          : {}),
        images: imagesPreview,
      }

      dispatch(createShowroom(Create, onCloseClick))
      // onCloseClick
    }
  }

  return (
    <Modal isOpen={show} toggle={onCloseClick} centered={true}>
      <ModalBody className="p-4">
        <CardTitle>
          {updateData?._id ? "Edit Showrooms" : "Add Showrooms"}
        </CardTitle>
        <AvForm
          onValidSubmit={(e, v) => {
            handleValidSubmit(e, v)
          }}
        >
          <Row>
            <>
              <Col className="px-2 " md={4}>
                <AvField
                  name="priority"
                  type="number"
                  className="form-control"
                  label="Priority"
                  value={updateData?.priority ?? ""}
                  validate={{
                    pattern: {
                      value: "^[1-9]\\d*$",
                      errorMessage: "Priority must be a positive number",
                    },
                  }}
                />
              </Col>
              <Col className="col-12 mb-2 mt-2">
                <label>
                  Google map URL
                  {/* <span className="text-danger"> *</span> */}
                </label>
                <AvField
                  name="google_map_url"
                  type="text"
                  placeholder="Enter Google map URL "
                  value={updateData?.google_map_url}
                />
              </Col>
            </>
          </Row>
          <Row>
            <Col className="col-12 mt-2">
              <UseImageUploader
                imageSize={4}
                setImagesPreview={images => {
                  setImagesPreview(images)
                  if (images.length > 0) setImageError("")
                }}
                imagesPreview={imagesPreview}
                uploadUrl={"/focusmotors"}
                // isMultiple
              />
              {imageError && (
                <div
                  className="text-danger mt-1"
                  style={{ fontSize: "0.9rem" }}
                >
                  {imageError}
                </div>
              )}
            </Col>
          </Row>

          <div className="d-flex justify-content-end align-items-center">
            <div className="text-center mt-3">
              <button
                type="button"
                className="btn btn-light ms-2"
                onClick={onCloseClick}
              >
                Cancel
              </button>
              <button type="submit" className="btn btn-warning ms-2">
                {updateData?._id ? "Save" : "Create"}
              </button>
            </div>
          </div>
        </AvForm>
      </ModalBody>
    </Modal>
  )
}

ShowroomModal.propTypes = {
  onCloseClick: PropTypes.func,
  show: PropTypes.any,
  updateData: PropTypes.any,
  setImagesPreview: PropTypes.any,
  imagesPreview: PropTypes.any,
}

export default ShowroomModal
